export default __webpack_public_path__ + "static/media/5.203f3886.jpg";